import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
import FooterSharedStyles from '../Shared/FooterShared.styles';
const Container = styled.section ``;
const Title = styled(FooterSharedStyles.Title) ``;
const List = styled.ul `
  display: flex;
  justify-content: center;
  margin: 0 0 24px;

  @media ${from(Device.Tablet)} {
    justify-content: flex-start;
  }
`;
const Item = styled.li `
  display: block;
  margin: 0;

  & + & {
    margin-left: 8px;
  }
`;
const Link = styled.a `
  display: flex;
  background: ${cssVar('fgColor')};
  border-radius: 50%;
  color: ${cssVar('bgColor')};
  height: 44px;
  ${fonts.gillSans.light};
  font-size: 20px;
  line-height: 30px;
  place-content: center;
  place-items: center;
  text-align: center;
  text-decoration: none;
  transform: scale(1);
  transition: transform 0.15s ease-out;
  width: 44px;

  &:focus,
  &:hover {
    outline: none;
    text-decoration: none;
    transform: scale(1.2);
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 16px;
    line-height: 28px;
    text-align: left;
  }
`;
const Icon = styled.img `
  display: block;
  height: 100%;
  max-height: 24px;
  max-width: 24px;
  object-fit: contain;
  object-position: center center;
  width: 100%;
`;
const Copyright = styled.p `
  ${fonts.gillSans.light};
  font-size: 14px;
  line-height: 22px;
`;
export default {
    Container,
    Copyright,
    Icon,
    Item,
    Link,
    List,
    Title,
};
